export default "__VITE_ASSET__DlGsJoek__"